module.exports = __webpack_public_path__ + "img/home_menu_8_selected.238f56f4.png";